import React from 'react';
import {connect} from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";
import {mm2ToM2, sqInchesToSqFoot} from "../../../../helpers/sqftHelper";

const SqftSummaryBumpouts = (props) => {
  const {measureUnit, intl} = props;
  const {bumpouts} = props;
  let messageTotal,
    bumpoutsArea = 0;

  for(let i = 0; i < bumpouts.length; i++) {
    bumpoutsArea += bumpouts[i].area;
  }

  switch(measureUnit) {
    case "Metric":
      messageTotal = "Total : "+  Math.ceil10(mm2ToM2(bumpoutsArea), -2) + "  m²";
      break;
    case "Imperial":
    default:
      messageTotal = intl.formatMessage({id: "sqft.navigation.summary.shapesTotal"}) + " " + Math.ceil(sqInchesToSqFoot(bumpoutsArea)) +"\'";
  }

  return (
    <div className="summary-list__item summary summary--blue">
      <div className="summary-title">
        <FormattedMessage id="sqft.navigation.summary.bumpouts"/>
      </div>
      <div className="summary-info">
        <div className="summary-info__left">
          <FormattedMessage id="sqft.navigation.summary.segments"/> : {bumpouts.length}
        </div>
        <div className="summary-info__right">
          { messageTotal }
        </div>
      </div>
    </div>
  )
};


const mapStateToProps = (store) => ({
  menuOpened: store.sqftMenuState.menuOpened,
  activeButton: store.sqftMenuState.activeButton,
  measureUnit: store.sqftState.measureUnit
});

const mapDispatchToProps = {};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(SqftSummaryBumpouts)
);
